module.exports = __webpack_public_path__ + "img/shoulder_width.8a253a5b.png";